(function(root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.MayLondonLookbook = factory();
})(typeof window !== 'undefined' ? window : globalThis, function() {
  const text = (value, max = 100) => typeof value === 'string' ? value.trim().slice(0, max) : '';
  const fold = value => text(value, 20000).normalize('NFKC').toLocaleLowerCase();
  function lines(values, reuse = true) {
    if (!Array.isArray(values)) return [];
    return values.filter(line => line && Number.isSafeInteger(line.quantity) && line.quantity > 0 && line.quantity <= 99 &&
      (line.kind === 'own' ? text(line.id) : line.kind === 'shop' && typeof line.handle === 'string' && line.handle.length <= 256 && /^[-\p{L}\p{N}\p{M}\u2122\u00ae]+$/u.test(line.handle) && typeof line.variantId === 'string'))
      .slice(0, 20).map(line => line.kind === 'own' ? {kind:'own', id:text(line.id), quantity:line.quantity} :
        {kind:'shop', handle:line.handle, variantId:reuse ? text(line.variantId) : '', quantity:line.quantity});
  }
  function preferences(value = {}) {
    const input = value && typeof value === 'object' ? value : {};
    return Object.fromEntries(['query','category','season','occasion','style','budget'].map(field => [field,
      field === 'budget' ? Math.max(0, Math.min(10000000, Number(input.budget) || 0)) : text(input[field])]));
  }
  function normalize(value) {
    if (!value || !text(value.id) || !text(value.name, 80) || !Array.isArray(value.lines)) return null;
    const prefs = preferences(value.preferences), metadata = value.metadata && typeof value.metadata === 'object' ? value.metadata : prefs;
    return {id:text(value.id), name:text(value.name,80), lines:lines(value.lines), preferences:prefs,
      metadata:{season:text(metadata.season,40), occasion:text(metadata.occasion,60)}};
  }
  function restore(values) {
    const seen = new Set();
    return (Array.isArray(values) ? values : []).map(normalize).filter(value => {
      if (!value || seen.has(value.id)) return false;
      seen.add(value.id); return true;
    }).slice(0,30);
  }
  function search(saved, filters = {}, products = [], own = []) {
    const query = fold(filters.query), season = fold(filters.season), occasion = fold(filters.occasion);
    const result = saved.filter(look => {
      if (season && fold(look.metadata.season) !== season) return false;
      if (occasion && fold(look.metadata.occasion) !== occasion) return false;
      if (filters.source === 'own' && !look.lines.some(line => line.kind === 'own')) return false;
      if (filters.source === 'shop' && !look.lines.some(line => line.kind === 'shop')) return false;
      const names = look.lines.map(line => {
        const item = line.kind === 'own' ? own.find(p => p.id === line.id) : products.find(p => p.handle === line.handle);
        return [item?.name, item?.title, item?.colour, item?.variants?.find(v => String(v.id) === line.variantId)?.title].filter(Boolean).join(' ');
      });
      const haystack = fold([look.name, look.metadata.season, look.metadata.occasion, ...names].join(' '));
      return !query || query.split(/\s+/).every(word => haystack.includes(word));
    });
    return filters.sort === 'name' ? result.sort((a,b) => a.name.localeCompare(b.name)) : result.reverse();
  }
  return {lines, preferences, normalize, restore, search};
});
